import { Chip, Divider, Typography } from '@mui/material';
import { Box, useTheme } from '@mui/system';
import { useLocation } from 'react-router-dom';
import { Firmware } from 'types/firmware';
import DOMPurify from 'dompurify';
import { useTranslation } from 'react-i18next';

const ViewFirmwareDetails = () => {
    const location = useLocation();
    const { firmware } = location.state as { firmware: Firmware };
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <Box>
            <Box display="flex" alignItems="center">
                <Typography variant="h1">{`${firmware.major ?? '-'}.${firmware.minor ?? '-'}`}</Typography>

                {!firmware.internal && (
                    <Chip
                        sx={{ marginLeft: 1 }}
                        color="primary"
                        size="small"
                        label={
                            <Typography variant="body2" color="#fff">
                                {t('INTERNAL_VERSION')}
                            </Typography>
                        }
                    />
                )}
            </Box>
            <Divider
                sx={{
                    borderColor: theme.palette.primary.main,
                    borderBottomWidth: 2,
                    marginTop: '2px',
                    marginBottom: '2px'
                }}
            />
            <Box sx={{ marginLeft: '5px' }}>
                <Typography variant="h2" sx={{ fontWeight: 'bold' }}>
                    {t('RELEASE_NOTES')}:
                </Typography>
                <HtmlRenderer html={firmware.releaseNote} />
            </Box>
        </Box>
    );
};

export default ViewFirmwareDetails;

const HtmlRenderer = ({ html }: { html: string }) => (
    <Box
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }}
        sx={{
            typography: 'body1',
            a: {
                color: 'primary.main',
                textDecoration: 'underline',
                '&:hover': {
                    color: 'secondary.main',
                    textDecoration: 'none'
                }
            }
        }}
    />
);
